"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLocal = setLocal;
exports.getLocal = getLocal;
exports.clearLocal = clearLocal;

// 设置localstorage
function setLocal(key, data) {
  window.localStorage.setItem(key, JSON.stringify(data));
} // 获取localstorage


function getLocal(key) {
  var data = window.localStorage.getItem(key);

  try {
    return JSON.parse(data);
  } catch (e) {
    return data;
  }
} // 清除localstorage


function clearLocal(key) {
  window.localStorage.clear(key);
}